// The full results table's helpers (Devin 2026-10-28: View Scores' Results
// tab shows "the full table as we would in public results"). A copy of the
// web app's src/Parent/Results/oireachtasResultsModel.js (the parts the table
// uses): keep the two alike. The data is the public results shape
// (GET /oireachtas/:id/competitions/:compId/results/preview). Named like the web app's file.

export const ord = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
};

// a place as the results books print it: "3rd", or "3T" when tied
export const placeLabel = (position, tied) => (position ? (tied ? `${position}T` : ord(position)) : "");

// Up to two decimals, no trailing zeros (85.5, 60, 62.33).
export const num = (v) => (v == null || v === "" ? "–" : String(Math.round(Number(v) * 100) / 100));

// Rounds and their panels, in order: [{ round, judges: [{ slot, name, photo }] }]
export const roundsOf = (detail) =>
  Object.keys(detail?.judgesByRound || {})
    .map(Number)
    .sort((a, b) => a - b)
    .map((round) => ({ round, judges: detail.judgesByRound[round] || [] }));

// One judge, one round (e.g. treble reel, trad set): like the feis single-judge
// table, no Irish points - the judge's score decides.
export const isSingleJudge = (detail) => {
  const r = roundsOf(detail);
  return r.length === 1 && r[0].judges.length === 1;
};

export const roundOf = (row, round) => (row?.rounds || []).find((r) => r.round === round) || null;
export const markOf = (row, round, slot) => (roundOf(row, round)?.judges || []).find((j) => j.slot === slot) || null;

// With a recall every recalled dancer with a place is placed; without one,
// the results' own placed flag. A multi-round competition without a recall
// must not show everyone as "Not recalled".
export const hasRecall = (detail) => roundsOf(detail).length > 1 && (detail?.rows || []).some((r) => r.recalled);

export const placedOf = (row, multiRound) => (multiRound ? !!(row.recalled && row.position) : !!row.placed);

// The table's dividers: placed dancers, then (with a recall) those not
// recalled, or (without one) those who did not place. A recalled dancer with
// no place failed to complete: never "Not recalled".
export const sectionOf = (row, multiRound) => {
  if (placedOf(row, multiRound)) return "placed";
  if (!multiRound) return "unplaced";
  return row.recalled ? "incomplete" : "notRecalled";
};
export const SECTION_LABEL = { unplaced: "Did not place", incomplete: "Did not complete", notRecalled: "Not recalled" };

// The Status column: WM (World medal holder), WQ (World qualifier), NQ (NAIDC
// qualifier), FTC (failed to complete). WM instead of WQ: one or the other.
export const statusOf = (row) => {
  const out = [];
  if ((row.status || []).includes("MW")) out.push("WM");
  else if ((row.qualifications || []).some((q) => q.key === "wq" || q.key === "wq_auto")) out.push("WQ");
  if ((row.qualifications || []).some((q) => q.key === "naidc")) out.push("NQ");
  if ((row.status || []).includes("FTC")) out.push("FTC");
  return out;
};

// Which judges' marks a round's high/low drop removed, from the live result
// (GET .../results stores the dropped VALUES, droppedHigh / droppedLow): on a
// tie the first judge in panel order with that value is the one marked. The
// backend's helpers/oireachtasPublicResults.js droppedSlots: keep the two
// alike. → { [slot]: "high" | "low" }
export const droppedSlots = (rr) => {
  const judges = rr?.judges || [];
  const out = {};
  const pick = (value, tag) => {
    if (value == null) return;
    const j = judges.find((x) => !out[x.slot] && x.points === value);
    if (j) out[j.slot] = tag;
  };
  pick(rr?.droppedHigh, "high");
  pick(rr?.droppedLow, "low");
  return out;
};
